export const CALENDAR_EVENT_SAVED_STATUS = 'CALENDAR_EVENT_SAVED_STATUS';
export const COMPOSING_EVENT = 'COMPOSING_EVENT';
export const EVENT_LOADED = 'EVENT_LOADED';
export const ASSOCIATE_ATTENDEE = 'ASSOCIATE_ATTENDEE';
export const SELECT_ORGANIZER = 'SELECT_ORGANIZER';
export const CANCEL_SELECT_CONTACT = 'CANCEL_SELECT_CONTACT';
export const SET_MATCHED_ORGANIZERS = 'SET_MATCHED_ORGANIZERS';
export const SET_SELECTED_CONTACTS = 'SET_SELECTED_CONTACTS';
export const SET_MATCHED_CONTACTS = 'SET_MATCHED_CONTACTS';
export const SELECTED_RECORD = 'SELECTED_RECORD';
export const DESELECT_RECORD = 'DESELECT_RECORD';
export const SET_EVENT_SUBJECT = 'SET_EVENT_SUBJECT';
export const SET_EVENT_START = 'SET_EVENT_START';
export const SET_EVENT_END = 'SET_EVENT_END';
export const SET_EVENT_LOCATION = 'SET_EVENT_LOCATION';
export const SET_EVENT_RECURRENCE = 'SET_EVENT_RECURRENCE';
export const SET_EVENT_ATTENDEES = 'SET_EVENT_ATTENDEES';
export const SET_OWNER_FOR_DELEGATED_CALENDAR = 'SET_OWNER_FOR_DELEGATED_CALENDAR';
export const SET_EVENT_ALL_DAY = 'SET_EVENT_ALL_DAY';
export const ATTENDEE_CHANGE = 'ATTENDEE_CHANGE';
export const MULTI_MATCH_ATTENDEE_FIXED = 'MULTI_MATCH_ATTENDEE_FIXED';
export const EVENT_PRESAVE = 'EVENT_PRESAVE';
export const EVENT_SAVED = 'EVENT_SAVED';
export const SET_EVENT_STATUS = 'SET_EVENT_STATUS';
export const SET_SALESFORCE_CONTACT_MAP = 'SET_SALESFORCE_CONTACT_MAP';
export const SET_SAVED_ATTENDEES = 'SET_SAVED_ATTENDEES';
export const ADDING_ATTENDEE = 'ADDING_ATTENDEE';
export const SET_ATTENDEES_TO_ADD = 'SET_ATTENDEES_TO_ADD';
export const SET_SALESFORCE_EVENT_ID = 'SET_SALESFORCE_EVENT_ID';
export const IS_MISSING_CONTACTS = 'IS_MISSING_CONTACTS';
export const IS_SELECTING_RECORD = 'IS_SELECTING_RECORD';
export const SET_ATTENDEE_BANNER = 'SET_ATTENDEE_BANNER';
export const SYNC_DISABLED = 'SYNC_DISABLED';
export const UNSYNC_EVENT = 'UNSYNC_EVENT';
export const IS_PRIVATE_EVENT_SF = 'IS_PRIVATE_EVENT_SF';
export const IS_CALENDAR_USER = 'IS_CALENDAR_USER';
export const DELEGATE_ERROR = 'DELEGATE_ERROR';
export const SET_RESYNC_JOB_ID = 'SET_RESYNC_JOB_ID';

export const calendarEventSavedStatus = (event, savedStatus) => (
  {
    type: CALENDAR_EVENT_SAVED_STATUS,
    calendarEvent: event.CalendarEvent,
    savedStatus,
    recentRecords: event.AllRecords,
    listViews: event.ListViewRecords,
    eventStatus: event.eventStatus,
  }
);

export const composingEvent = (eventId) => ({
  type: COMPOSING_EVENT,
  eventId,
});

export const eventLoaded = (eventId) => ({
  type: EVENT_LOADED,
  eventId,
});

export const eventPresave = (calendarEvent) => ({
  type: EVENT_PRESAVE,
  calendarEvent,
});

export const associateAttendee = (contactListObject) => ({
  type: ASSOCIATE_ATTENDEE,
  contactListObject,
});

export const selectOrganizer = (contact) => ({
  type: SELECT_ORGANIZER,
  contact,
});

export const cancelSelectContact = () => ({
  type: CANCEL_SELECT_CONTACT,
});

export const setMatchedOrganizers = (contactListMap) => ({
  type: SET_MATCHED_ORGANIZERS,
  contactListMap,
});

export const setSelectedContacts = (contactListMap) => ({
  type: SET_SELECTED_CONTACTS,
  contactListMap,
});

export const setAttendeeBanner = (attendeeBannerToggle) => ({
  type: SET_ATTENDEE_BANNER,
  attendeeBannerToggle,
});

export const setMatchedContacts = (contactListMap) => ({
  type: SET_MATCHED_CONTACTS,
  contactListMap,
});

export const selectRecord = (item) => ({
  type: SELECTED_RECORD,
  selectedRecord: item,
});

export const deselectRecord = () => ({
  type: DESELECT_RECORD,
});

export const setEventSubject = (eventSubject) => ({
  type: SET_EVENT_SUBJECT,
  eventSubject,
});

export const setEventStart = (eventStart) => ({
  type: SET_EVENT_START,
  eventStart,
});

export const setEventEnd = (eventEnd) => ({
  type: SET_EVENT_END,
  eventEnd,
});

export const setEventLocation = (eventLocation) => ({
  type: SET_EVENT_LOCATION,
  eventLocation,
});

export const setEventRecurrence = (eventRecurrence) => ({
  type: SET_EVENT_RECURRENCE,
  eventRecurrence,
});

export const setEventAttendees = (eventAttendees) => ({
  type: SET_EVENT_ATTENDEES,
  eventAttendees,
});

export const setOwnerForDelegatedCalendar = (ownerForDelegatedCalendar) => ({
  type: SET_OWNER_FOR_DELEGATED_CALENDAR,
  ownerForDelegatedCalendar,
});

export const setEventAllDay = (eventAllDay) => ({
  type: SET_EVENT_ALL_DAY,
  eventAllDay,
});

export const attendeeChange = () => ({
  type: ATTENDEE_CHANGE,
});

export const multiMatchAttendeeFixed = () => ({
  type: MULTI_MATCH_ATTENDEE_FIXED,
});


export const eventSaved = (calendarEvent) => ({
  type: EVENT_SAVED,
  calendarEvent,
});

export const setEventStatus = (eventStatus) => ({
  type: SET_EVENT_STATUS,
  eventStatus,
});

export const setSalesforceContactMap = (contactMap) => ({
  type: SET_SALESFORCE_CONTACT_MAP,
  contactMap,
});

export const setSavedEventAttendees = (attendees) => ({
  type: SET_SAVED_ATTENDEES,
  attendees,
});

export const addingAttendee = (isAdding) => ({
  type: ADDING_ATTENDEE,
  isAdding,
});

export const setAttendeesToAdd = (attendeesToAdd) => ({
  type: SET_ATTENDEES_TO_ADD,
  attendeesToAdd,
});

export const setSalesforceEventId = (eventId) => ({
  type: SET_SALESFORCE_EVENT_ID,
  eventId,
});

export const isMissingContacts = (isMissingContacts) => ({
  type: IS_MISSING_CONTACTS,
  isMissingContacts,
});

export const isSelectingRecord = (isSelectingRecord) => ({
  type: IS_SELECTING_RECORD,
  isSelectingRecord,
});

export const syncDisabled = (syncDisabled) => ({
  type: SYNC_DISABLED,
  syncDisabled,
});

export const unsyncEvent = () => ({
  type: UNSYNC_EVENT,
});

export const isPrivateEventSF = (isPrivateEventSF) => ({
  type: IS_PRIVATE_EVENT_SF,
  isPrivateEventSF,
});

export const isCalendarUser = (isCalendarUser) => ({
  type: IS_CALENDAR_USER,
  isCalendarUser,
});

export const delegateError = (delegateError) => ({
  type: DELEGATE_ERROR,
  delegateError,
});

export const setResyncJobId = (resyncJobId) => ({
  type: SET_RESYNC_JOB_ID,
  resyncJobId,
});
